import React, { useState, useEffect } from 'react';
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import BuildTab3 from '../BuildSheet/BuildTab3';
import { Link, useHistory } from "react-router-dom";
import { getPrescription } from "../../Api/prescriptionApis";
import { getCurrentUser } from "../../Api/auth";
import { IoCloseSharp } from "react-icons/io5";
import { getremoteInquirydataApi, getsingleprescription } from "../../Api/iron"
import LeftScript2 from './LeftScript2';
import PrescTab from '../BuildSheet/PrescTab';
import { getInventoryByType } from "../../Api/inventoryApi";
import { getallModeldatabymake } from "../../Api/inventoryApi";
import { adddatatoprescriptionapi } from "../../Api/inventoryApi";
import Spinner from 'react-bootstrap/Spinner';


const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};


const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};


function NewPrescription2() {

    const history = useHistory();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get('id');

    const [prescription, setPrescription] = useState(initialPrescriptionState);

    const [userdata, setUserdata] = useState('');

    const [apicall, setApicall] = useState(false);

    const [scrolled, setScrolled] = useState(false);

    const [prescriptionid, setPrescriptionid] = useState(null)

    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);
    const [SinglePrescription, setSinglePrescription] = useState(0);
    const [fittingdata, setFittingData] = useState(null);
    const [optimalHeadsdata, setOptimalHeadsdata] = useState(null);
    const [optimalShaftsdata, setOptimalShaftsdata] = useState(null);
    const [optimalGripsdata, setOptimalGripsdata] = useState(null);



    useEffect(() => {
        getprojectdata();
        getallmakedata(0);
        getprescriptionDataById();
        getallModels();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const getprojectdata = () => {
        setApicall(true);
        const data = {
            'project_id': id
        }
        getPrescription(data).then((res) => {
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicall(false);
                setPrescription(res.data.data);
                setPrescriptionid(res.data.data._id)
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        getRemortFittingDataById();


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);


    const goBack = () => {
        history.goBack();
    };

    const [remortFittingFormData, setRemortFittingFormData] = useState(initData);
    const [studioshow, setstudioShow] = useState(false);



    const getRemortFittingDataById = () => {
        getremoteInquirydataApi({ id: id }).then((res) => {
            if (res?.code === 200) {
                const userData = res.data.data;
                setRemortFittingFormData(userData);
                setFittingData(userData.fittingdata);
                setOptimalHeadsdata(userData?.optimalHeads);
                setOptimalShaftsdata(userData?.optimalShafts);
                setOptimalGripsdata(userData?.optimalGrips);
                // setstudioShow(userData.studio_fitting === 0 ? false : true);
                setstudioShow(!!userData.studio_fitting);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
    }, [remortFittingFormData]);

    const [allMakeData, setallMakeData] = useState([]);

    const getallmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByType(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setallMakeData(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const getprescriptionDataById = () => {
        getsingleprescription({ project_id: id }).then((res) => {
            if (res?.code === 200) {
                const prescriptionData = res.data.data;
                setSinglePrescription(prescriptionData);
            } else {
                // alert(res.data?.message);
                //setSinglePrescription(null);
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const [allmodels, setAllModels] = useState([]);

    const getallModels = () => {
        getallModeldatabymake().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setAllModels(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const [isFormValid, setIsFormValid] = useState({
        bounce: '',
        lieage: '',
        shaftweight: '',
        shaftflex: '',
        shaftprofile: '',
        gripSize: '',
        clubLength: '',
        swingWeight: '',

        bounceselect: '',
        lieageselect: '',
        shaftweightselect: '',
        shaftflexselect: '',
        shaftprofileselect: '',
        gripSizeselect: '',
        clubLengthselect: '',
        swingWeightselect: '',
    });

    const [checkdropdwondata, setcheckdropdwondata] = useState({});


    const [isValid, setIsValid] = useState(false);

    console.log("isFormValid", isFormValid);

    const isFieldValid = (value) => {
        return typeof value === 'string' && value.trim() !== '';
    };
    // Function to check if all fields are filled
    const validateForm = () => {
        // Validate checkdropdwondata fields (ensure dropdowns exist and are valid)
        const dropdownValid = checkdropdwondata &&
            ["optimalHeads", "optimalShafts", "optimalGrips"].every(key => {
                return checkdropdwondata[key] && Object.values(checkdropdwondata[key]).every(option => {
                    return isFieldValid(option.make) && isFieldValid(option.model);
                });
            });

        // Set the validation state if both form and dropdowns are valid
        setIsValid(dropdownValid);
    };

    useEffect(() => {
        validateForm();


        setOptimalHeadsdata(checkdropdwondata?.optimalHeads);
        setOptimalShaftsdata(checkdropdwondata?.optimalShafts);
        setOptimalGripsdata(checkdropdwondata?.optimalGrips);

    }, [isFormValid, checkdropdwondata]);


    const [preloader, setPreloader] = useState(false);

    const adddatatoprecription = () => {
        if (id) {
            setPreloader(true);
            const data = {
                project_id: id,
                fitter_name: `${userdata.firstname + ' ' + userdata.lastname}`,
                prescription_user_id: remortFittingFormData.user_id,
                fitter_id: `${userdata._id}`
            };
            adddatatoprescriptionapi(data)
                .then((res) => {
                    if (!res.data.status) {
                        setErrors(res.data.data);
                        setPreloader(false);
                        alert(res.data.data[0].detail);
                    } else {
                        setPreloader(false);
                        window.location.href = `/project/prescription/prescription-view/${remortFittingFormData?._id}`;
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                });
        } else {
            console.log("success");
        }
    };

    const handleClick = (e) => {
        alert("Please add prescriptions first");
    }

    useEffect(() => {

    }, [SinglePrescription])




    // const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);



    return (
        <>
            {
                remortFittingFormData.firstname != "" ? (
                    <>
                        <div className="main-page-body-content-header">
                            <HeaderAdmin />
                        </div>

                        <div className='design_show_mobile'>
                            <div className='fixed-btn'>
                                {
                                    ((isFormValid?.bounce ?? "") !== "" || (isFormValid?.bouncedropdownselect ?? "") !== "") &&
                                        ((isFormValid?.lieage ?? "") !== "" || (isFormValid?.lieageselect ?? "") !== "") &&
                                        ((isFormValid?.shaftweight ?? "") !== "" || (isFormValid?.shaftweightselect ?? "") !== "") &&
                                        ((isFormValid?.shaftflex ?? "") !== "" || (isFormValid?.shaftflexselect ?? "") !== "") &&
                                        ((isFormValid?.shaftprofile ?? "") !== "" || (isFormValid?.shaftprofileselect ?? "") !== "") &&
                                        ((isFormValid?.gripSize ?? "") !== "" || (isFormValid?.gripSizeselect ?? "") !== "") &&
                                        ((isFormValid?.clubLength ?? "") !== "" || (isFormValid?.clubLengthselect ?? "") !== "") &&
                                        ((isFormValid?.swingWeight ?? "") !== "" || (isFormValid?.swingWeightselect ?? "") !== "") &&

                                        ((fittingdata?.bounce ?? "") !== "" || (fittingdata?.bouncedropdownselect ?? "") !== "") &&
                                        ((fittingdata?.lieage ?? "") !== "" || (fittingdata?.lieageselect ?? "") !== "") &&
                                        ((fittingdata?.shaftweight ?? "") !== "" || (fittingdata?.shaftweightselect ?? "") !== "") &&
                                        ((fittingdata?.shaftflex ?? "") !== "" || (fittingdata?.shaftflexselect ?? "") !== "") &&
                                        ((fittingdata?.shaftprofile ?? "") !== "" || (fittingdata?.shaftprofileselect ?? "") !== "") &&
                                        ((fittingdata?.gripSize ?? "") !== "" || (fittingdata?.gripSizeselect ?? "") !== "") &&
                                        ((fittingdata?.clubLength ?? "") !== "" || (fittingdata?.clubLengthselect ?? "") !== "") &&
                                        ((fittingdata?.swingWeight ?? "") !== "" || (fittingdata?.swingWeightselect ?? "") !== "") &&

                                        ((optimalHeadsdata?.option1.make ?? "") !== "" || (optimalHeadsdata?.option1.model ?? "") !== "") &&
                                        ((optimalHeadsdata?.option2.make ?? "") !== "" || (optimalHeadsdata?.option2.model ?? "") !== "") &&
                                        ((optimalHeadsdata?.option3.make ?? "") !== "" || (optimalHeadsdata?.option3.model ?? "") !== "") &&

                                        ((optimalShaftsdata?.option1.make ?? "") !== "" || (optimalShaftsdata?.option1.model ?? "") !== "") &&
                                        ((optimalShaftsdata?.option2.make ?? "") !== "" || (optimalShaftsdata?.option2.model ?? "") !== "") &&
                                        ((optimalShaftsdata?.option3.make ?? "") !== "" || (optimalShaftsdata?.option3.model ?? "") !== "") &&

                                        ((optimalGripsdata?.option1.make ?? "") !== "" || (optimalGripsdata?.option1.model ?? "") !== "") &&
                                        ((optimalGripsdata?.option2.make ?? "") !== "" || (optimalGripsdata?.option2.model ?? "") !== "") &&
                                        ((optimalGripsdata?.option3.make ?? "") !== "" || (optimalGripsdata?.option3.model ?? "") !== "") ? (
                                        SinglePrescription === 0 ? (
                                            <button onClick={adddatatoprecription}>
                                                {
                                                    preloader ? (<Spinner animation="border" className="border-black" />) : (<span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g fill="#000"><path d="m24 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><g clip-rule="evenodd" fill-rule="evenodd"><path d="m14.4096 6.15808c-.2665.90082-.4096 1.85466-.4096 2.84191 0 5.52281 4.4772 10.00001 10 10.00001h14c5.5229 0 10-4.4772 10-10.00001 0-.98725-.1431-1.94109-.4096-2.84191 3.6564.73752 6.4096 3.96822 6.4096 7.84192v22.2481c-1.8374-.8028-3.8667-1.2481-6-1.2481-8.2843 0-15 6.7157-15 15 0 2.9412.8465 5.6846 2.3091 8h-19.3091c-4.4183 0-8-3.5817-8-8v-36c0-3.8737 2.7532-7.1044 6.4096-7.84192zm3.5904 19.84192c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-24c-1.1046 0-2-.8954-2-2zm2 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2h14c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 10c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2z" /><path d="m48 38c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12-5.3726-12-12-12zm0 18.0004c-1.1046 0-2-.8955-2-2v-2.0003h-2c-1.1046 0-2-.8954-2-2 0-1.1045.8954-2 2-2h2v-1.9997c0-1.1046.8954-2 2-2s2 .8954 2 2v1.9997h2c1.1046 0 2 .8955 2 2 0 1.1046-.8954 2-2 2h-2v2.0003c0 1.1045-.8954 2-2 2z" /></g></g></svg>
                                                    </span>)
                                                }

                                            </button>
                                        ) : (
                                            <button  >
                                                <a href={`/project/prescription/prescription-view/${remortFittingFormData?._id}`}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g fill="#000"><path d="m24 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><g clip-rule="evenodd" fill-rule="evenodd"><path d="m14.4096 6.15808c-.2665.90082-.4096 1.85466-.4096 2.84191 0 5.52281 4.4772 10.00001 10 10.00001h14c5.5229 0 10-4.4772 10-10.00001 0-.98725-.1431-1.94109-.4096-2.84191 3.6564.73752 6.4096 3.96822 6.4096 7.84192v22.2481c-1.8374-.8028-3.8667-1.2481-6-1.2481-8.2843 0-15 6.7157-15 15 0 2.9412.8465 5.6846 2.3091 8h-19.3091c-4.4183 0-8-3.5817-8-8v-36c0-3.8737 2.7532-7.1044 6.4096-7.84192zm3.5904 19.84192c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-24c-1.1046 0-2-.8954-2-2zm2 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2h14c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 10c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2z" /><path d="m48 38c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12-5.3726-12-12-12zm0 18.0004c-1.1046 0-2-.8955-2-2v-2.0003h-2c-1.1046 0-2-.8954-2-2 0-1.1045.8954-2 2-2h2v-1.9997c0-1.1046.8954-2 2-2s2 .8954 2 2v1.9997h2c1.1046 0 2 .8955 2 2 0 1.1046-.8954 2-2 2h-2v2.0003c0 1.1045-.8954 2-2 2z" /></g></g></svg>
                                                </a>

                                            </button>
                                        )
                                    ) : (
                                        <button style={{ opacity: "0.5" }} onClick={handleClick}>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g fill="#000"><path d="m24 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><g clip-rule="evenodd" fill-rule="evenodd"><path d="m14.4096 6.15808c-.2665.90082-.4096 1.85466-.4096 2.84191 0 5.52281 4.4772 10.00001 10 10.00001h14c5.5229 0 10-4.4772 10-10.00001 0-.98725-.1431-1.94109-.4096-2.84191 3.6564.73752 6.4096 3.96822 6.4096 7.84192v22.2481c-1.8374-.8028-3.8667-1.2481-6-1.2481-8.2843 0-15 6.7157-15 15 0 2.9412.8465 5.6846 2.3091 8h-19.3091c-4.4183 0-8-3.5817-8-8v-36c0-3.8737 2.7532-7.1044 6.4096-7.84192zm3.5904 19.84192c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-24c-1.1046 0-2-.8954-2-2zm2 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2h14c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 10c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2z" /><path d="m48 38c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12-5.3726-12-12-12zm0 18.0004c-1.1046 0-2-.8955-2-2v-2.0003h-2c-1.1046 0-2-.8954-2-2 0-1.1045.8954-2 2-2h2v-1.9997c0-1.1046.8954-2 2-2s2 .8954 2 2v1.9997h2c1.1046 0 2 .8955 2 2 0 1.1046-.8954 2-2 2h-2v2.0003c0 1.1045-.8954 2-2 2z" /></g></g></svg>
                                        </button>
                                    )
                                }

                            </div>
                        </div>
                        <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec inline-btn-dashboard side-marginfix">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                {/* <div className="sec-dashboard-header-title">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Prescription</h3>
                                        </div>
                                    </div> */}
                                                <div className="sec-header-new">
                                                    <button type="button" className="btn-header-transparent">
                                                        <div className="border_box_view">
                                                            <div className="border_box_view_inner">
                                                                <div className="box_icon">
                                                                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#99ea24"><path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><path clip-rule="evenodd" d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z" fill-rule="evenodd" /></g></svg>
                                                                </div>
                                                                <div className="box_text_content">
                                                                    <div className="big_text">New Fitting</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>

                                                    <div className="header-left">
                                                        <Link to={`/project/project-view/${id}`}>
                                                            <button type="button" className="btn-header-transparent me-3">
                                                                <div className="border_box_view">
                                                                    <div className="border_box_view_inner">
                                                                        <div className="box_icon">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" fill-rule="evenodd" height="512" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" width="512"><g id="Icon" fill='#99ea24'><path d="m15.479 22.75h-11.479c-.729 0-1.429-.29-1.945-.805-.515-.516-.805-1.216-.805-1.945v-16c0-.729.29-1.429.805-1.945.516-.515 1.216-.805 1.945-.805h8.586c.464 0 .909.184 1.237.513l4.414 4.414c.329.328.513.773.513 1.237v4.151c-.687-.101-1.386-.084-2.068.05-.575.112-1.055.505-1.28 1.046l-.17.41c-.224-.029-.441-.057-.441-.057-.581-.076-1.161.143-1.546.585-.521.598-.922 1.291-1.179 2.042-.19.554-.09 1.166.266 1.631l.271.353c-.137.179-.271.353-.271.353-.356.465-.456 1.077-.266 1.631.257.751.658 1.444 1.179 2.042.385.442.965.661 1.546.585l.441-.057c.086.208.17.41.17.41.023.055.049.109.077.161zm-9.979-8h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75zm7-11.75v3.5c0 .552.448 1 1 1h3.5zm-7 8.25h8c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-8c-.414 0-.75.336-.75.75s.336.75.75.75zm0 7h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75z" /><path d="m19.396 13.044s.355.855.354.855c.135.068.266.144.393.226l.918-.12c.248-.032.497.062.662.251.436.5.771 1.081.987 1.709.081.237.038.5-.115.699 0 0-.562.735-.562.734.008.151.008.303 0 .453l.562.735c.153.199.196.462.115.699-.216.628-.551 1.209-.987 1.709-.165.189-.414.283-.662.251 0 0-.918-.12-.917-.121-.127.083-.259.159-.393.227l-.355.855c-.096.232-.302.4-.548.448-.652.128-1.322.128-1.974 0-.246-.048-.452-.216-.548-.448 0 0-.355-.855-.354-.855-.135-.068-.267-.144-.393-.226l-.918.12c-.249.032-.497-.062-.662-.251-.437-.5-.772-1.081-.987-1.709-.081-.237-.038-.5.114-.699 0 0 .563-.735.563-.734-.008-.151-.008-.303 0-.453l-.563-.735c-.152-.199-.195-.462-.114-.699.215-.628.55-1.209.987-1.709.165-.189.413-.283.662-.251 0 0 .918.12.917.121.127-.083.258-.159.393-.227l.355-.855c.096-.232.302-.4.548-.448.652-.128 1.322-.128 1.974 0 .246.048.452.216.548.448zm-1.535 3.081c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5z" /></g></svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        </Link>
                                                        <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                            <div className="border_box_view">
                                                                <div className="border_box_view_inner">
                                                                    <div className="box_icon">
                                                                        <IoCloseSharp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="dashboard-sec">
                                                    <div className="row">
                                                        <div className='design_hide_mobile'>
                                                            {
                                                                SinglePrescription != undefined && <LeftScript2 project_id={id} allMakeData={allMakeData} remortFittingFormData={remortFittingFormData} setRemortFittingFormData={setRemortFittingFormData} setIsFormValid={setIsFormValid} SinglePrescription={SinglePrescription} studioshow={studioshow} />
                                                            }

                                                        </div>
                                                        <div className={`col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ${scrolled ? "tab_fix" : ""}`}>
                                                            <div className="fix_sec_view container-fluid ps-0">
                                                                {
                                                                    ((isFormValid?.bounce ?? "") !== "" || (isFormValid?.bouncedropdownselect ?? "") !== "") &&
                                                                        ((isFormValid?.lieage ?? "") !== "" || (isFormValid?.lieageselect ?? "") !== "") &&
                                                                        ((isFormValid?.shaftweight ?? "") !== "" || (isFormValid?.shaftweightselect ?? "") !== "") &&
                                                                        ((isFormValid?.shaftflex ?? "") !== "" || (isFormValid?.shaftflexselect ?? "") !== "") &&
                                                                        ((isFormValid?.shaftprofile ?? "") !== "" || (isFormValid?.shaftprofileselect ?? "") !== "") &&
                                                                        ((isFormValid?.gripSize ?? "") !== "" || (isFormValid?.gripSizeselect ?? "") !== "") &&
                                                                        ((isFormValid?.clubLength ?? "") !== "" || (isFormValid?.clubLengthselect ?? "") !== "") &&
                                                                        ((isFormValid?.swingWeight ?? "") !== "" || (isFormValid?.swingWeightselect ?? "") !== "") &&

                                                                        ((fittingdata?.bounce ?? "") !== "" || (fittingdata?.bouncedropdownselect ?? "") !== "") &&
                                                                        ((fittingdata?.lieage ?? "") !== "" || (fittingdata?.lieageselect ?? "") !== "") &&
                                                                        ((fittingdata?.shaftweight ?? "") !== "" || (fittingdata?.shaftweightselect ?? "") !== "") &&
                                                                        ((fittingdata?.shaftflex ?? "") !== "" || (fittingdata?.shaftflexselect ?? "") !== "") &&
                                                                        ((fittingdata?.shaftprofile ?? "") !== "" || (fittingdata?.shaftprofileselect ?? "") !== "") &&
                                                                        ((fittingdata?.gripSize ?? "") !== "" || (fittingdata?.gripSizeselect ?? "") !== "") &&
                                                                        ((fittingdata?.clubLength ?? "") !== "" || (fittingdata?.clubLengthselect ?? "") !== "") &&
                                                                        ((fittingdata?.swingWeight ?? "") !== "" || (fittingdata?.swingWeightselect ?? "") !== "") &&

                                                                        ((optimalHeadsdata?.option1.make ?? "") !== "" || (optimalHeadsdata?.option1.model ?? "") !== "") &&
                                                                        ((optimalHeadsdata?.option2.make ?? "") !== "" || (optimalHeadsdata?.option2.model ?? "") !== "") &&
                                                                        ((optimalHeadsdata?.option3.make ?? "") !== "" || (optimalHeadsdata?.option3.model ?? "") !== "") &&

                                                                        ((optimalShaftsdata?.option1.make ?? "") !== "" || (optimalShaftsdata?.option1.model ?? "") !== "") &&
                                                                        ((optimalShaftsdata?.option2.make ?? "") !== "" || (optimalShaftsdata?.option2.model ?? "") !== "") &&
                                                                        ((optimalShaftsdata?.option3.make ?? "") !== "" || (optimalShaftsdata?.option3.model ?? "") !== "") &&

                                                                        ((optimalGripsdata?.option1.make ?? "") !== "" || (optimalGripsdata?.option1.model ?? "") !== "") &&
                                                                        ((optimalGripsdata?.option2.make ?? "") !== "" || (optimalGripsdata?.option2.model ?? "") !== "") &&
                                                                        ((optimalGripsdata?.option3.make ?? "") !== "" || (optimalGripsdata?.option3.model ?? "") !== "") ? (
                                                                        SinglePrescription === 0 ? (
                                                                            <div className="btn-box-section mt-0 design_hide_mobile">
                                                                                <button className="btn btn-primary btn-create" onClick={adddatatoprecription}>
                                                                                    {
                                                                                        preloader ? (<Spinner animation="border" className="border-black" />) : (<span>Create Prescription</span>)
                                                                                    }

                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="btn-box-section mt-0 design_hide_mobile">
                                                                                <button className="btn btn-primary btn-create">
                                                                                    <a href={`/project/prescription/prescription-view/${remortFittingFormData?._id}`}>View Prescription</a>

                                                                                    {/* <Link to={`/project/prescription/prescription-view/${remortFittingFormData?._id}`}>View Prescription</Link> */}
                                                                                </button>
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <div className="btn-box-section mt-0 design_hide_mobile">
                                                                            <button className="btn btn-primary btn-create" style={{ opacity: "0.5" }} onClick={handleClick}>
                                                                                Create Prescription
                                                                            </button>
                                                                        </div>
                                                                    )
                                                                }
                                                                {
                                                                    allMakeData && allMakeData.length > 0 ? (
                                                                        <>
                                                                            <div className='design_hide_mobile'>
                                                                                <BuildTab3 project_id={id} project_step={`${prescriptionid === null || prescriptionid === undefined
                                                                                    ? "prescription" : "prescription"}`} allmodels={allmodels} remortFittingFormData={remortFittingFormData} allMakeData={allMakeData} SinglePrescription={SinglePrescription} prescriptioncalc={prescription} setcheckdropdwondata={setcheckdropdwondata} studioshow={studioshow} />
                                                                            </div>

                                                                            <div className='design_show_mobile'>
                                                                                <PrescTab project_id={id} project_step={`${prescriptionid === null || prescriptionid === undefined
                                                                                    ? "prescription" : "prescription"}`} allmodels={allmodels} remotefittingdataofdata={remortFittingFormData} prescriptioncalc={prescription} SinglePrescription={SinglePrescription} allMakeData={allMakeData} setcheckdropdwondata={setcheckdropdwondata} studioshow={studioshow} />
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <style>
                            {`.right_fix_sec {
  margin-top: 1px;
  transition: margin-top 0.9s ease-in-out;
}

.right_fix_sec.tab_fix {
  margin-top: 1px;
}`}
                        </style>
                    </>) : (<> </>)
            }
        </>
    );
}

export default NewPrescription2;